import React, { memo, useEffect } from 'react'
import { fetchOrders } from 'actions/OrderActions'
import Chat from 'supportAssistant/components/Chat/Chat'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { areOrdersBeingFetched, haveOrdersBeenFetched } from 'lib/order/orderUtils'
import { selectLoggedIn } from 'selectors/accountSelectors'
import useChatListener from 'supportAssistant/hooks/useChatListeners'
import useChats from 'supportAssistant/hooks/useChats'

function ChatPage() {
  const dispatch = useAppDispatch()
  const isLoggedIn = useAppSelector(selectLoggedIn)
  const ordersFetched = useAppSelector(state => haveOrdersBeenFetched(state, 'upcoming'))
  const ordersFetching = useAppSelector(state => areOrdersBeingFetched(state, 'upcoming'))

  useChatListener()
  useChats()

  useEffect(() => {
    if (isLoggedIn && !ordersFetched && !ordersFetching) {
      dispatch(fetchOrders({ status: 'upcoming' }))
    }
  }, [dispatch, isLoggedIn, ordersFetched, ordersFetching])

  return <Chat />
}

export default memo(ChatPage)
